import React from 'react';
import Avatar from 'layout/atoms/Avatar/Avatar';
import Portal from 'layout/atoms/Portal/Portal';
import env from 'utils/env';
import styles from './MentionsDropdown.module.scss';
function MentionsDropdown({ users, selectedIndex, onSelect, visible, inputRef, }) {
    if (!visible || users.length === 0) {
        return null;
    }
    const getPosition = () => {
        if (!(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current))
            return { top: 0, left: 0 };
        const rect = inputRef.current.getBoundingClientRect();
        const position = {
            top: rect.top + window.scrollY - 8,
            left: rect.left + window.scrollX,
        };
        return position;
    };
    const position = getPosition();
    return (React.createElement(Portal, null,
        React.createElement("div", { className: styles.dropdown, style: {
                top: position.top,
                left: position.left,
            } },
            React.createElement("div", { className: styles.content }, users.map((user, index) => (React.createElement("button", { type: "button", key: user.id, className: `${styles.item} ${index === selectedIndex ? styles.selected : ''}`, onClick: () => onSelect(user) },
                React.createElement(Avatar, { size: "s", userName: user.username, src: user.avatar ? `${env.static}/${user.avatar}` : null }),
                React.createElement("span", { className: styles.username }, user.username))))))));
}
export default MentionsDropdown;
